module.exports = __webpack_public_path__ + "img/ban_03.1b58a0d7.png";